import React from 'react';

import { useBoolean } from 'util/hooks';

function Image(props) {
  const { alt, children, downloadUrl, clickToOpen, actions, hideOnError, ..._props } = props;
  const [error, setError] = useBoolean(false);

  const handleClick = React.useCallback(() => {
    if (clickToOpen) window.open(downloadUrl ?? _props.src, '_blank');
  }, [downloadUrl, clickToOpen, _props.src]);

  if (hideOnError && error) return null;

  return error ? (
    children ?? (
      <div className="no-msg" title={_props.title ?? alt}>
        No image available
      </div>
    )
  ) : (
    <React.Fragment>
      <img
        onClick={handleClick}
        onLoad={setError.false}
        onError={setError.true}
        alt={alt ?? _props.title}
        {..._props}
      />
    </React.Fragment>
  );
}

export default React.memo(Image);
